import React, {
	useCallback,
	useEffect,
	useState,
	useMemo,
	FC,
	ReactNode,
} from 'react';

import Slider from './Slider';
import Item from './Item';
import Track from './Track';

export interface CarouselPropTypes {
	children: ReactNode[];
	gap: number;
}

const Carousel: FC<CarouselPropTypes> = ({ children, gap }) => {
	const [trackIsActive, setTrackIsActive] = useState(false);
	const [sliderWidth, setSliderWidth] = useState(0);
	const [activeItem, setActiveItem] = useState(0);
	const [itemWidth, setItemWidth] = useState(0);

	const initSliderWidth = useCallback(
		(width: number) => setSliderWidth(width),
		[],
	);

	const positions = useMemo(
		() =>
			children?.map(
				(_, index: number) => -Math.abs((itemWidth + gap) * index),
			),
		[children, itemWidth, gap],
	);

	useEffect(() => {
		setItemWidth(sliderWidth / children.length - gap);
	}, [sliderWidth, gap]);

	const sliderProps = {
		setTrackIsActive,
		initSliderWidth,
		setActiveItem,
		activeItem,
		itemWidth,
		positions,
		gap,
	};

	const trackProps = {
		setTrackIsActive,
		trackIsActive,
		setActiveItem,
		sliderWidth,
		activeItem,
		itemWidth,
		positions,
		gap,
	};

	const itemProps = {
		setTrackIsActive,
		trackIsActive,
		setActiveItem,
		activeItem,
		positions,
	};

	return (
		<Slider {...sliderProps}>
			<Track {...trackProps}>
				{children.map((child: any, index: number) => (
					<Item {...itemProps} index={index} key={index}>
						{child}
					</Item>
				))}
			</Track>
		</Slider>
	);
};

export default Carousel;
